export default "__VITE_ASSET__ffb2fe8a__"